import {US_STATES} from '@gfiber/typesmith/us_states';

export const MAX_TITLE_LENGTH = 255;
export const MAX_FILE_SIZE_MB = 15;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const ACCEPTED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
];
export const ACCEPTED_FILE_TYPES_STRING = ACCEPTED_FILE_TYPES.map(t =>
  t.split('/')[1].toUpperCase(),
).join(', ');
export const RECAPTCHA_TOKEN_KEY = 'recaptchaToken';
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_KEY;
export const KILO_BYTE_SIZE = 1024;
export const FILE_SIZE_UNITS = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
export const PRIVACY_POLICY_URL = 'https://gfiber.com/legal/privacy/';
export const TERMS_OF_SERVICE_URL = 'https://gfiber.com/legal/terms/';
export const HELP_CENTER_URL = 'https://gfiber.com/support/en/';
export const VALIDATION_MESSAGES = {
  REQUIRED: 'errors.required',
  INVALID_EMAIL: 'errors.invalidEmail',
  FILE_TOO_LARGE: 'errors.fileTooLarge',
  INVALID_MIME_TYPE: 'errors.invalidMimeType',
  INVALID_ZIP_CODE: 'errors.invalidZipCode',
  ONLY_DIGITS: 'errors.onlyDigits',
  INVALID_PHONE: 'errors.invalidPhone',
  INVALID_DATE: 'errors.invalidDate',
  DATE_CANNOT_BE_FUTURE: 'errors.dateCannotBeFuture',
};
export const DATA_REQUEST_STATE_CODES = [
  'CA',
  'CO',
  'FL',
  'TX',
  'UT',
  'TN',
  'IA',
  'NE',
] as const;
export const DATA_REQUEST_STATES = DATA_REQUEST_STATE_CODES.flatMap(code => {
  const state = US_STATES.find(s => s.code === code);
  return state ? [state] : [];
});
